import { DataDetailInformationItem } from '@/api-client/metav6/model';
import { convertToStatDataType } from '../statList';
import { StatDetailInfo } from './statDetail.types';

export const convertStatDetailFromDto = (
  detailInfo: DataDetailInformationItem,
): StatDetailInfo => ({
  id: detailInfo.dataId ?? '',
  name: detailInfo.displayName ?? '',
  dataType: detailInfo.dataType?.split(',').map(convertToStatDataType) ?? [],
  platform: detailInfo.pcategory ?? '',
  category: detailInfo.ccategory ?? '',
  description: detailInfo.description ?? '',
  unit: detailInfo.unit ?? '',
  tags: detailInfo.tag ? detailInfo.tag.split(',').filter(Boolean) : [],
  arguments: detailInfo.arguments?.reduce<Record<string, string>>((acc, argument) => {
    const key = Object.keys(argument)[0];
    acc[key] = argument[key];
    return acc;
  }, {}),
});
